import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid py-4 text-light",
  style: {"background-color":"var(--background-color-dark)"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "savvyText" }
const _hoisted_4 = { class: "savvyText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "text-center text-light" }, "Don't Overcharge For Prescriptions", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-center" }, "IntelligentRx is for Savvy Techs", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[3] || (_cache[3] = _createTextVNode(" With ", -1)),
        _createVNode(_component_router_link, {
          class: "text-light light-link",
          to: "/goodrx-comparison#betterForPharmacies"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("lower pharmacy fees than GoodRx", -1)
          ]))]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" and ", -1)),
        _createVNode(_component_router_link, {
          class: "text-light light-link",
          to: "/goodrx-comparison#betterPrices"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("better or comparable prices", -1)
          ]))]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createTextVNode(", IntelligentRx is better for your pharmacy and better for consumers, and ", -1)),
        _createVNode(_component_router_link, {
          class: "text-light light-link",
          to: "/goodrx-comparison#goodrx-comparison"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("we have the data", -1)
          ]))]),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" to prove it. ", -1))
      ]),
      _createElementVNode("p", _hoisted_4, [
        _cache[8] || (_cache[8] = _createTextVNode(" Get started now with IntelligentRx by searching for a drug, viewing prices via our ", -1)),
        _createVNode(_component_router_link, {
          class: "text-light light-link",
          to: "/goodrx-comparison#goodrx-comparison"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("GoodRx Comparison page", -1)
          ]))]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createTextVNode(", or downloading our ", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("a", {
          href: "https://apps.apple.com/us/app/intelligentrx/id1611042374",
          class: "text-light light-link"
        }, "iOS", -1)),
        _cache[11] || (_cache[11] = _createTextVNode(" or ", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("a", {
          href: "https://play.google.com/store/apps/details?id=com.intelligentrx",
          class: "text-light light-link"
        }, "Android", -1)),
        _cache[13] || (_cache[13] = _createTextVNode(" apps. ", -1))
      ])
    ])
  ]))
}